import React from 'react';
import { Connection } from 'flow/types/Connection';
import PbxMenuIcon from './PbxMenuIcon';
import CallButton from '../CallButton';
import Divider from '../ui-components/Divider';
import { TypedMap } from 'flow/types/TypedMap';
import NumberWrapper from '../ui-components/NumberWrapper';
import SettingSection from '../Setting/SettingSection';
import useAppContext from 'flow/hooks/useAppContext';
import { homeActionUrlPath } from 'flow/utils';

type Props = {
    connection: TypedMap<Connection>;
};

const PbxConnectionSettings = ({ connection }: Props) => {
    const { i18next } = useAppContext();

    const number = connection.get('number');
    const model = connection.getIn(['terminal', 'model']);
    const mac = connection.getIn(['terminal', 'mac']);
    const iconPath = homeActionUrlPath(
        '/img/terminals/' + connection.getIn(['terminal', 'avatarUrl']),
    );

    return (
        <div>
            <div className="flex h-13 items-center justify-between rounded-sm p-2">
                <div className="flex items-center gap-x-3">
                    <PbxMenuIcon iconKey="settingsInputHdmi" />

                    <NumberWrapper>
                        {number.get('nationalFormat')}
                    </NumberWrapper>
                </div>

                <div className="flex justify-end">
                    <CallButton phoneNumber={number.get('number')} />
                </div>
            </div>

            <Divider />

            <SettingSection>
                {i18next.t('pbx.connections.current_phone')}
            </SettingSection>

            {connection.has('terminal') ? (
                <div className="flex flex-row items-center">
                    <div className="me-3 w-full overflow-hidden">
                        <div className="text-sm text-gray-800">
                            {i18next.t('pbx.connections.model')}
                        </div>
                        <div className="text-gray-800">{model}</div>
                        <div className="text-sm text-gray-800">
                            {i18next.t('pbx.connections.mac')}
                        </div>
                        <div className="text-gray-800">
                            <NumberWrapper>{mac}</NumberWrapper>
                        </div>
                    </div>
                    <div>
                        {/* Decorative: the model name is rendered as text beside it. */}
                        <img className="w-full" src={iconPath} alt="" />
                    </div>
                </div>
            ) : (
                <div className="me-3 w-full overflow-hidden">
                    {i18next.t('pbx.connections.missing_phone')}
                </div>
            )}
        </div>
    );
};

export default PbxConnectionSettings;
